import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboOperario`, method: 'GET', body: null, token: token})
}
